import { throttled } from './utils';

let cursorEls;
let interactEls;
let peachEls;

const init = () => {
  cursorEls = document.querySelectorAll('.js-cursor');
  interactEls = document.querySelectorAll('a, button, input, .o-button');
  peachEls = document.querySelectorAll('.o-block--peach, .o-block--peach + .c-footer, .c-navigation, .c-overlay--menu');

  document.addEventListener('mousemove', throttledSetMousePos);

  peachEls.forEach((el) => {
    el.addEventListener('mouseenter', () =>
      cursorEls.forEach(cursor => cursor.classList.add('is-dark')));
    el.addEventListener('mouseleave', () =>
      cursorEls.forEach(cursor => cursor.classList.remove('is-dark')));
  });

  interactEls.forEach((el) => {
    el.addEventListener('mouseenter', () =>
      cursorEls.forEach(cursor => cursor.classList.add('is-hovering')));
    el.addEventListener('mouseleave', () =>
      cursorEls.forEach(cursor => cursor.classList.remove('is-hovering')));
  });
};

const reset = () => {
  const interactionStates = ['is-hovering'];
  cursorEls.forEach(el => el.classList.remove(...interactionStates));
};

const setMousePos = (e) => {
  const pointerX = e.clientX;
  const pointerY = e.clientY;

  cursorEls.forEach(cursor => {
    cursor.style.setProperty('--pointerX', pointerX + 'px');
    cursor.style.setProperty('--pointerY', pointerY + 'px');
  });

};

const throttledSetMousePos = throttled(10, setMousePos);


export default { init, reset };
